export default class ErrorFormResponse {
  common?: string[]
  email?: string[]
  firstname?: string[]
  lastname?: string[]
  password?: string[]
  jobRoles?: string[]
  phone?: string[]
  zipCode?: string[]
  agreeCheck?: string[]
  recaptcha?: string[]
  urlParam?: string[]
  currentPassword?: string[]
  newPassword?: string[]
  confirmPassword?: string[]
  newEmail?: string[]
  confirmEmail?: string[]
  authCode?: string[]
  updateDttm?: string[]
  voluntaryWithdrawalId?: string[]
  voluntaryWithdrawalReason?: string[]
}
